export default "__VITE_ASSET__7f6bc327__"